((function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("mainFooter", {
        templateUrl: "app/mainFooter.component.html",
        controller: ["authService", "frameworkService", "$localStorage", "$rootScope", "$scope", "$state", "$uibModal", "_", MainFooterCtrl],
        controllerAs: "vm"
    });
    function MainFooterCtrl(authService, frameworkService, $localStorage, $rootScope, $scope, $state, $uibModal, _) {
        var vm = this;
        vm.currentLocalizationId = 0;
        vm.userDetails = authService.authentication;
        vm.frameworkData = frameworkService.data;
        vm.changeLanguage = changeLanguage;
        vm.openContactUsModal = openContactUsModal;
        vm.currentYear = new Date().getFullYear();
        $rootScope.$on("$translateChangeSuccess", function () {
            updateFooter(false);
        });
        $rootScope.$on("signInComplete", function () {
            updateFooter(true);
        });
        $rootScope.$on("userSignedOut", function () {
            updateFooter(true);
        });
        $rootScope.$watch(function () { return vm.frameworkData.isFrameworkLoaded; }, function () {
            updateFooter(false);
        });
        ///////////////////////////////////////////////////////////
        function updateFooter(forceUpdate) {
            //forceUpdate for signing in/out and changing view of private pages
            if (vm.frameworkData.isFrameworkLoaded) {
                if (forceUpdate || vm.currentLocalizationId !== $localStorage.currentLocalizationId) {
                    vm.currentLocalizationId = $localStorage.currentLocalizationId;
                    if (vm.selectedLanguageId !== $localStorage.currentLocalizationId)
                        vm.selectedLanguageId = $localStorage.currentLocalizationId;
                    vm.footer = _.find(vm.frameworkData.tenant.footers, { localizationId: vm.currentLocalizationId });
                    vm.pages = _.filter(angular.copy(vm.frameworkData.tenant.pages), function (page) {
                        return (vm.userDetails.isAuth || page.isPublic) && page.localizationId === vm.currentLocalizationId;
                    });
                }
            }
        }
        function changeLanguage() {
            var localization = _.find(vm.enabledLocalizations, { id: vm.selectedLanguageId });
            frameworkService.setLocale(localization.languageCulture, localization.id, localization.name, function () {
                window.location.reload();
            });
        }
        function openContactUsModal() {
            //$uibModal.open({
            //	templateUrl: "app/public/contactUsView.html",
            //	controller: "ContactUsCtrl as vm",
            //	scope: $scope,
            //	backdrop: "static",
            //	resolve: {
            //		userInfo: function () {
            //			return {
            //				firstName: vm.userDetails.userFirstName,
            //				lastName: vm.userDetails.userLastName,
            //				email: vm.userDetails.userEmail,
            //				tenantId: vm.frameworkData.tenant.id,
            //				regNumber: vm.userDetails.userPersonSeq
            //			};
            //		}
            //	}
            //}).result.catch(angular.noop);
            $rootScope.$broadcast("openContactUs", {
                firstName: vm.userDetails.userFirstName,
                lastName: vm.userDetails.userLastName,
                email: vm.userDetails.userEmail,
                tenantId: vm.frameworkData.tenant.id,
                regNumber: vm.userDetails.userPersonSeq
            });
        }
    }
})());
